module.exports = __webpack_public_path__ + "static/media/icon_28.5d625dfc.svg";